import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../i18n/I18nContext";
import ProductCard from "../components/ProductCard";

export default function Shop() {
  const { t } = useI18n();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  return (
    <main className="max-w-[1400px] mx-auto px-6 md:px-12 pt-16 pb-24" data-testid="shop-page">
      <header className="mb-16 fade-in">
        <div className="label-caps text-muted-foreground mb-4">{t("nav.shop")}</div>
        <h1 className="font-hand text-6xl md:text-7xl leading-tight mb-6">{t("shop.title")}</h1>
        <p className="text-base md:text-lg text-muted-foreground max-w-xl">
          {t("shop.subtitle")}
        </p>
      </header>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-14" data-testid="product-grid">
        {products.map((p, i) => (
          <ProductCard
            key={p.id}
            product={p}
            className={i % 5 === 0 ? "lg:col-span-2" : ""}
          />
        ))}
      </div>
    </main>
  );
}
